@if (person) {
  <div class="page-content page-fill">
    <div class="dx-toolbar mb-4">
      <dx-button text="Save" type="success" (onClick)="save()" class="my-auto"></dx-button>
      <dx-button text="Cancel" type="danger" (onClick)="close()"></dx-button>
      <div class="d-inline-block ms-4">
        <h3 class="d-inline fw-bold align-middle me-4">{{ person.firstName }} {{ person.lastName }}</h3>
        <label class="dx-box-item-content d-inline-block align-middle me-1 mb-0">
          Last Updated
        </label>
        <dx-date-box [(value)]="person.interestsLastUpdated" class="d-inline-block"> </dx-date-box>
      </div>
      <dx-button text="Today" type="normal" (onClick)="today()" class="ms-1"></dx-button>
      <dx-button text="Clear" type="default" (onClick)="clear()" class="ms-4"></dx-button>
    </div>
    <div style="columns: 350px;">
      @for (category of categories; track category) {
        <div>
          <strong>{{ category.name }}</strong>
          @for (i of category.interests; track i) {
            <div>
              <label style="padding-top:0;">
                <input type="checkbox" style="margin-top:0; margin-bottom:3px;" [(ngModel)]="i.selected" />
                {{ i.name }}
              </label>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
